import React from 'react';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';

const getMargin = el => {
  const computed = window.getComputedStyle(el);
  return parseInt(computed.marginBottom, 10);
};

const getHeight = el => (el ? el.clientHeight : 0);

const getOuterHeight = el => (el ? el.clientHeight + getMargin(el) : 0);

export const LayoutContext = React.createContext();

class LayoutManager extends React.Component {
  constructor(props) {
    super(props);

    this.navRef = React.createRef();
    this.priceSummaryExpandedRef = React.createRef();

    this.state = {
      height: 0,
      navRef: this.navRef,
      priceSummaryExpandedRef: this.priceSummaryExpandedRef
    };
  }

  componentDidMount() {
    this.intervalId = setInterval(() => {
      const navHeight = getOuterHeight(this.navRef.current);
      const summaryHeight = getHeight(this.priceSummaryExpandedRef.current);
      const isLarge = MediaQuery.atLeast('large');
      const height = isLarge ? navHeight - summaryHeight : navHeight;

      if (height !== this.state.height) {
        this.setState({ height });
      }
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    return (
      <LayoutContext.Provider value={this.state}>
        {this.props.children}
      </LayoutContext.Provider>
    );
  }
}

export default LayoutManager;
